import { Link, useLocation } from 'react-router-dom';
import { Home, Building2, Search, Heart, User } from 'lucide-react';
import { cn } from '@/lib/utils';

const tabs = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/projects', label: 'Projects', icon: Building2 },
  { to: '/buy', label: 'Search', icon: Search, center: true },
  { to: '/dashboard/favorites', label: 'Favorites', icon: Heart },
  { to: '/dashboard', label: 'Profile', icon: User },
];

export function MobileBottomNav() {
  const { pathname } = useLocation();
  const isActive = (to: string) =>
    to === '/' ? pathname === '/' : pathname.startsWith(to);

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-background border-t shadow-[0_-2px_10px_rgba(0,0,0,0.06)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Mobile navigation"
    >
      <ul className="flex items-end justify-around h-16">
        {tabs.map(t => {
          const Icon = t.icon;
          const active = isActive(t.to);
          if (t.center) {
            return (
              <li key={t.to} className="flex-1 flex justify-center">
                <Link
                  to={t.to}
                  className="-mt-6 flex flex-col items-center gap-0.5"
                  aria-label={t.label}
                >
                  <span className="h-12 w-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg ring-4 ring-background">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="text-[10px] text-muted-foreground mt-0.5">{t.label}</span>
                </Link>
              </li>
            );
          }
          return (
            <li key={t.to} className="flex-1">
              <Link
                to={t.to}
                className={cn(
                  'flex flex-col items-center justify-center gap-0.5 h-full pt-2',
                  active ? 'text-primary' : 'text-muted-foreground'
                )}
              >
                <Icon className={cn('h-5 w-5', active && 'fill-primary/10')} />
                <span className="text-[10px] font-medium">{t.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
